import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectIsFocus } from "../routes/Search/search.ducks";

export const useOutsideAlerter = (
  menuRef: any,
  inputRef: any,
  callback: () => void
) => {
  const isFocus = useSelector(selectIsFocus);

  useEffect(() => {
    function handleClickOutside(event: any) {
      const target = event.target;

      // Ignore clicks on elements with data-prevent-close attribute
      if (target && target.closest && target.closest('[data-prevent-close]')) {
        return;
      }

      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.input.contains(event.target) &&
        isFocus
      ) {
        callback();
      }
    }

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [menuRef, inputRef, isFocus]);
};



// WEBPACK FOOTER //
// ./src/utils/useOutsideClick.ts